<template>
    <img :src="computedSrc" @click="openGLightBox" :class="{allowZoom: allowZoom}" :alt="alt"/>
</template>

<script>
import GLightBox from 'glightbox' // https://github.com/biati-digital/glightbox

const portaLocatedImg = "https://supereasy1.com/archivosSubidos/receta/"

require('glightbox/dist/css/glightbox.min.css')

export default {
    name: 'imgPortal',
    props:{
        src: {
            type: [String],
            requred: true
        },
        alt: {
            type: [String]
        },
        allowZoom: {
            type: [Boolean, Number, String],
            default: false
        }
    },
    data: () => {
        return {
            lBox: null
        }
    },
    computed: {
        computedSrc(){
            if(this.src == null | this.src == '')
                return "https://storage.supereasy1.com/img/render/aab9ab5b8648335f07ad079381ff04a2/3"
            let reg = /^http(.+)$/
            return (reg.test(this.src)) ? this.src : (portaLocatedImg + this.src)
        }
    },
    methods: {
        openGLightBox() {
            if(this.allowZoom && this.allowZoom != 'false' && !!this.src) {
                this.lBox = new GLightBox()
                this.lBox.insertSlide({
                    href: this.src,
                    type: 'image'
                })
                this.lBox.open()
            } else {
                console.log(this.allowZoom)
            }
        }
    }
}
</script>


<style scoped>
    IMG {
        width: 4em;
        height: 4em;
        object-fit: cover;
        border-radius: .5em;
        border: 1px solid rgb(187, 187, 187);
    }
</style>